import { axiosConsignadoInstance } from "../axiosInstance";
import { FinancialInsuranceReportListResponseDto, PaginationInputDto, FinancialInsuranceReportAggregateByHashDvo, FinancialProcessorReportListResponseDto, FinancialProcessorReportAggregateByHashDvo, FinancialProofsDetails, FinancialReportListResponse } from "./dto/financial-reports.dto";


export const getFinancialInsuranceReports = async (
  params: PaginationInputDto
): Promise<FinancialInsuranceReportListResponseDto[]> => {
  try {
    const response = await axiosConsignadoInstance.get(
      `/api-consignado-trabalhador/v1/financial-report/list/insurance`,
      {
        params: {
          ...params,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao obter Propostas:", error);
    throw error;
  }
};

export const getFinancialProcessorReports = async (
  params: PaginationInputDto
): Promise<FinancialProcessorReportListResponseDto[]> => {
  try {
    const response = await axiosConsignadoInstance.get(
      `/api-consignado-trabalhador/v1/financial-report/list/processor`,
      {
        params: {
          ...params,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao obter Propostas:", error);
    throw error;
  }
};

export const getFinancialInsuranceReportAggregateByHash = async (
): Promise<FinancialInsuranceReportAggregateByHashDvo[]> => {
  try {
    const response = await axiosConsignadoInstance.get(
      `/api-consignado-trabalhador/v1/financial-report/list/insurance/summarized`,
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao obter Propostas:", error);
    throw error;
  }
};

export const getFinancialProcessorReportAggregateByHash = async (
): Promise<FinancialProcessorReportAggregateByHashDvo[]> => {
  try {
    const response = await axiosConsignadoInstance.get(
      `/api-consignado-trabalhador/v1/financial-report/list/processor/summarized`,
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao obter Propostas:", error);
    throw error;
  }
};

export const uploadFinancialReport = async (file: File): Promise<any> => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const response = await axiosConsignadoInstance.post(
      `/api-consignado-trabalhador/v1/financial-report/upload`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao fazer upload do arquivo:", error);
    throw error;
  }
};

export const uploadFinancialProcessorReport = async (file: File): Promise<any> => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const response = await axiosConsignadoInstance.post(
      `/api-consignado-trabalhador/v1/financial-report/upload`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao fazer upload do arquivo:", error);
    throw error;
  }
};

export const uploadFinancialProofReport = async (file: File, financialReportId: string): Promise<any> => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('financialReportId', financialReportId);

    const response = await axiosConsignadoInstance.post(
      `/api-consignado-trabalhador/v1/financial-report/upload/proof-payment`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao fazer upload do comprovante:", error);
    throw error;
  }
}


export const getInsuranceProofs = async (hash: string): Promise<FinancialProofsDetails[]> => {
  try {
    const response = await axiosConsignadoInstance.get(
      `/api-consignado-trabalhador/v1/financial-report/list/proof-payment/${hash}/insurance`,
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao obter Propostas:", error);
    throw error;
  }
}

export const getProcessorProofs = async (hash: string): Promise<FinancialProofsDetails[]> => {
  try {
    const response = await axiosConsignadoInstance.get(
      `/api-consignado-trabalhador/v1/financial-report/list/proof-payment/${hash}/processor`,
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao obter Propostas:", error);
    throw error;
  }
}



export const getInsuranceReportExcel = async (hash: string): Promise<any> => {
  try {
    const response = await axiosConsignadoInstance.get(
      `/api-consignado-trabalhador/v1/financial-report/insurance/${hash}`,
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao obter Propostas:", error);
    throw error;
  }
}

export const getProcessorReportExcel = async (hash: string): Promise<any> => {
  try {
    const response = await axiosConsignadoInstance.get(
      `/api-consignado-trabalhador/v1/financial-report/processor/${hash}`,
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao obter Propostas:", error);
    throw error;
  }
}

export const getFinancialReportReceipts = async (financialReportId: string): Promise<string[]> => {
  try {
    const response = await axiosConsignadoInstance.get(
      `/api-consignado-trabalhador/v1/financial-report/receipts/${financialReportId}`,
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao obter comprovantes do relatório financeiro:", error);
    throw error;
  }
}

export const getFinancialReportsList = async (
  params: {
    take: string;
    skip: string;
    startDate?: string;
    endDate?: string;
  }
): Promise<FinancialReportListResponse> => {
  try {
    const response = await axiosConsignadoInstance.get(
      `/api-consignado-trabalhador/v1/financial-report/list`,
      {
        params: {
          ...params,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao obter lista de relatórios financeiros:", error);
    throw error;
  }
};